export default "__VITE_PUBLIC_ASSET__663329f7__"